import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import { useRoleService } from 'services/role';
import { Role } from 'types/role';

interface DeleteRoleModalProps {
  show: boolean;
  onHide: () => void;
  role: Role | null;
  onSuccess: (id: string) => void;
  onError: (message: string) => void;
}

const DeleteRoleModal: React.FC<DeleteRoleModalProps> = ({
  show,
  onHide,
  role,
  onSuccess,
  onError,
}) => {
  const roleService = useRoleService();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!role) return;

    setLoading(true);
    try {
      await roleService.deleteRole(role.id);
      onSuccess(role.id);
    } catch (error) {
      console.error('Failed to delete role:', error);
      const message =
        error instanceof Error ? error.message : 'Failed to delete role.';
      onError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete the role <strong>{role?.name}</strong>
          ? This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="outline"
          onClick={() => void handleDelete()}
          disabled={loading}
          style={{
            color: 'hsl(0 84.2% 60.2%)',
            borderColor: 'hsl(0 84.2% 60.2%)',
          }}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRoleModal;
